export function accordion() {
    /*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 */

    'use strict';

    class Accordion {
        constructor(domNode) {
            this.accordion = domNode
            const accordionItems = this.accordion.querySelectorAll('h5');
            this.items = [];
            accordionItems.forEach((accordionEl) => {
                this.items.push(new AccordionItems(accordionEl));
            })

            this.items.forEach((el, index) => {
                el.buttonEl.addEventListener('click', () => {
                    const defaultImage = this.accordion.parentElement.querySelector(".default-image");

                    if (defaultImage) {
                        defaultImage.querySelectorAll("img").forEach(function (el, i) {
                            if (index + 1 !== i && el.classList.contains("active")) {
                                el.classList.remove("active");
                            } else if (index + 1 === i && !el.classList.contains("active")) {
                                el.classList.add("active");
                            } else {
                                el.classList.remove("active");
                            }
                        })
                    }
                    this.openItem(el)
                })
                // this.showDefaultImage(el);
            })

        }

        showDefaultImage(el) {
            if (this.accordion.parentElement.classList.contains('accordion-with-image')) {
                if (el.open) {
                    this.accordion.parentElement.classList.remove("show-default-image")
                } else {
                    this.accordion.parentElement.classList.add("show-default-image")
                }
            }
        }

        openItem(el) {
            this.items.forEach((it) => {
                if (it !== el) {
                    it.close()
                } else {
                    it.onButtonClick(!it.open)
                    // this.showDefaultImage(it)
                }
            })
        }
    }

    class AccordionItems {
        constructor(domNode) {
            this.rootEl = domNode;
            this.buttonEl = this.rootEl.querySelector('button[aria-expanded]');

            this.contentEl = this.rootEl.parentNode.children[1];
            this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';

            // add event listeners
            // this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
        }

        onButtonClick() {

            this.toggle(!this.open);
        }

        toggle(open) {
            // don't do anything if the open state doesn't change
            if (open === this.open) {
                return;
            }

            // update the internal state
            this.open = open;

            // handle DOM updates
            this.buttonEl.setAttribute('aria-expanded', `${open}`);
            if (open) {
                this.contentEl.removeAttribute('hidden');
            } else {
                this.contentEl.setAttribute('hidden', '');
            }
        }

        // Add public open and close methods for convenience
        open() {
            this.toggle(true);
        }

        close() {
            this.toggle(false);
        }
    }

    // init accordions
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach((accordion) => {
        new Accordion(accordion);
    });

    $(".accordion-with-image").each(function () {
        const $this = $(this);
        const defaultImage = $this.find(".default-image");
        $this.find(".accordion .item").each(function (i, el) {
            let imageClone = $(el).find(".image img").clone();
            defaultImage.append(imageClone);
        })
        defaultImage.find('img').eq(1).addClass("active");
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/accordion.js